angular.module('galilai.creator').controller('OnboardingController', function($scope, $rootScope, api, $timeout) {
    $scope.classification = null
    $scope.loading = false

    $scope.currentStep = 1

    const IS_CATEGORY_REQUIRED = false

    $scope.isCategoryRequired = IS_CATEGORY_REQUIRED

    $scope.nextStep = function() {
        if ($scope.currentStep < 3) {
            $scope.currentStep++
        }
    }

    $scope.prevStep = function() {
        if ($scope.currentStep > 1) {
            $scope.currentStep--
        }
    }

    $scope.isLastStep = function() {
        return $scope.currentStep === 3
    }

    $scope.$watch('config', function() {

    })

    $scope.getCategories = function() {
        api.getImporterCategories().then(function(res) {
            function convertValues(item) {
                let row = {
                    value: item.key,
                    label: item.name,
                }
                if (item.keywords) {
                    row.keywords = item.keywords
                }
                return row
            }
            let data = res.data
            data.areas = data.areas.map(convertValues)
            data.areas.push({
                value: 'generic',
                label: 'Default',
            })
            data.categories = data.categories.map(convertValues)
            data.professions = data.professions.map(convertValues)
            data.objectives = data.objectives.map(convertValues)
            // Value/label map
            $scope.objectivesMap = {}
            data.objectives.forEach(function(objective) {
                $scope.objectivesMap[objective.value] = objective.label
            })
            $scope.classification = data
        })
        .catch(function(e) {
            console.error('Error fetching categories', e)
        })
    }

    $scope.selectGoal = function(goal) {
        if (!$scope.config.data.global) {
            $scope.config.data.global = {}
        }
        $scope.config.data.global.focus = goal
        // Save project
        $scope.saveProject()
        if ($scope.steps && $scope.isStepValid(2)) {
            $scope.nextStep()
        }
    }

    $scope.selectCategory = function(category) {
        if (!$scope.config.data.global) {
            $scope.config.data.global = {}
        }
        $scope.config.data.global.category = category
        // Save project
        $scope.saveProject()
    }

    $scope.selectServiceType = function(type) {
        if (!$scope.config.data.global) {
            $scope.config.data.global = {}
        }
        $scope.config.data.global.serviceType = type
        // Save project
        $scope.saveProject()

        if ($scope.steps && $scope.isStepValid(1)) {
            $scope.nextStep()
        }
    }

    $scope.selectAutomation = function(level) {
        if (!$scope.config.data.global) {
            $scope.config.data.global = {}
        }
        $scope.config.data.global.automation = level
        // Save project
        $scope.saveProject()
    }

    $scope.onChangeCategory = function() {
        // Save project
        $scope.saveProject()
    }

    let debounceSave = null
    $scope.saveProject = function(dismiss) {
        if (!$scope.isValid()) {
            return
        }
        if (debounceSave) {
            clearTimeout(debounceSave)
        }
        let params = {}
        let keysToUpdate = ['focus', 'category', 'serviceType', 'automation']
        for (let key of keysToUpdate) {
            if ($scope.config.data.global && $scope.config.data.global[key] !== undefined) {
                params[key] = $scope.config.data.global[key]
            }
        }

        if (params?.automation == 'high') {
            safeSetStorage('generator.advancedView', 'false')
        }

        debounceSave = setTimeout(() => {
            $scope.loading = true
            api.updateProjectGlobalSingle($scope.config._id, params).then((res) => {
            })
            .catch((err) => {
                console.error('Error saving project global data', err)
            })
            .finally(() => {
                debounceSave = null
                $scope.loading = false
                $timeout(angular.noop) // Trigger digest
                if (dismiss) {
                    let onboardingModal = angular.element('#onboarding-modal')
                    if (onboardingModal) {
                        onboardingModal.modal('hide')
                    }
                }
            })
        }, 100)
    }

    $scope.isStepValid = function(step) {
        if (!$scope.config || !$scope.config.data || !$scope.config.data.global) {
            return false;
        }
        var g = $scope.config.data.global;

        if (step === 1) {
            // Only category + serviceType are required here
            return !!((g.category || !IS_CATEGORY_REQUIRED) && g.serviceType);
        }
        if (step === 2) {
            // Only objective (focus) required here
            return !!g.focus;
        }
        if (step === 3) {
            // Only automation required here (Save button uses overall isValid anyway)
            return !!g.automation;
        }
        return false;
    };

    $scope.isValid = function() {
        if (!$scope.config || !$scope.config.data || !$scope.config.data.global) {
            return false
        }
        let requiredFields = ['focus', 'category', 'serviceType', 'automation']
        if (!IS_CATEGORY_REQUIRED) {
            requiredFields = requiredFields.filter(field => field !== 'category')
        }
        for (let field of requiredFields) {
            if (!$scope.config.data.global[field] || $scope.config.data.global[field] === '') {
                return false
            }
        }
        return true
    }

    $scope.init = function() {
        $scope.getCategories()
    }
})

